import { createApp } from 'vue'
import App from '@/App.vue'
import store from '@/store'
import router from '@/router';

import { IonicVue } from '@ionic/vue';

import { basicContentTransition } from './utils/custom-transition/basic';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Icons used inside text for unicode usage.
*  For accessing them inside of text use this class:
*    .inline-fa-icons
*  Or css with sans-serif fallback:
*    font-family: var(--ion-font-family, sans-serif), sans-serif, 'Font Awesome 6 Free';
*/
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';

/* Custom font */
import './fonts/geist/sans/font-face.css';
import './fonts/geist/mono/font-face.css';

/* Theme variables */
import './theme/variables.css';

/* Custom designs */
import './theme/custom-designs.css';

/* Swiper with custom Ionic Styles */
import './theme/ionic-custom-swiper.css';
import { register } from 'swiper/element/bundle';
register();

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { registerWithUpdateCallback } from './registerServiceWorker';

registerWithUpdateCallback(function (registration, reloadWithoutWait) { //First service worker is not waiting
  //Once there is an update, add notification to enable skipWaiting call and trigger refreshs
  if (store != null) {
    store.commit('addNotification', {
      title: (reloadWithoutWait) ? 'update_available_offline' : 'update_available',
      description: (reloadWithoutWait) ? 'restart_app_offline' : 'restart_app',
      translate: true,
      action: (reloadWithoutWait) ? 'sw_update_noskip' : 'sw_update',
      action_text: 'restart',
      no_persist: true,
      not_user_related: true
    });
  }
});

defineCustomElements(window);

const app = createApp(App)
//app.config.performance = true; //TODO Only enable when not in production!
app.use(store)
  .use(IonicVue, {
    mode: 'md',
    animated: true,
    navAnimation: basicContentTransition
  })
  .use(router);

router.isReady().then(() => {
  app.mount('#app');
});
